module.exports = __webpack_public_path__ + "img/default-steam-item.d31f0785.png";